var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#F1C10A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8595 20.918C17.5281 20.918 17.2595 20.6493 17.2595 20.318L17.2595 9.36937L14.7434 11.8848C14.5091 12.1191 14.1292 12.119 13.8949 11.8847C13.6606 11.6503 13.6607 11.2704 13.895 11.0361L17.431 7.50108L17.8554 7.07688L17.8595 7.08106L17.8598 7.08078L18.284 7.50516L21.8185 11.0417C22.0528 11.2761 22.0527 11.656 21.8183 11.8902C21.5839 12.1245 21.204 12.1243 20.9698 11.89L18.4595 9.37834L18.4595 20.318C18.4595 20.6493 18.1908 20.918 17.8595 20.918Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1405 7.07813C10.4719 7.07813 10.7405 7.34676 10.7405 7.67813L10.7405 18.6267L13.2566 16.1113C13.4909 15.877 13.8708 15.8771 14.1051 16.1114C14.3394 16.3458 14.3393 16.7257 14.105 16.96L10.569 20.495L10.1446 20.9192L10.1405 20.915L10.1402 20.9153L9.71604 20.4909L6.18148 16.9544C5.94723 16.72 5.94733 16.3401 6.18171 16.1059C6.41609 15.8716 6.79599 15.8717 7.03024 16.1061L9.54048 18.6177L9.54054 7.67812C9.54055 7.34675 9.80918 7.07812 10.1405 7.07813Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.581a28be.svg";
export { ForwardRef as ReactComponent };